import { render, staticRenderFns } from "./MultipleUploader.vue?vue&type=template&id=5512d27b&scoped=true&"
import script from "./MultipleUploader.vue?vue&type=script&lang=js&"
export * from "./MultipleUploader.vue?vue&type=script&lang=js&"
import style0 from "./MultipleUploader.vue?vue&type=style&index=0&id=5512d27b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5512d27b",
  null
  
)

export default component.exports